import React from "react";
import SpriteButton from "./SpriteButton";
import NFTButton from "./NFTButton";

function AnimationMenu({ setAnimation, setDisplaySelector, toggleNFT }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };
  // names of the shared VoxEdit animations (see public/vx/anims.json)
  const handleMenuOne = () => {
    setAnimation('Wave 01');
    setOpen(false);
  };

  const handleMenuTwo = () => {
    setAnimation('Walk 01');
    setOpen(false);
  };
  const handleMenuThree = () => {
    setAnimation('Idle 01');
    setOpen(false);
  };
  const handleMenuFour = () => {
    setAnimation('Dance 01');
    setOpen(false);
  };

  async function handleToggleDisplay() {
    setDisplaySelector(0)
  }

  async function toggleTwoD() {
    setDisplaySelector(2);
  }
  return (
  <div className="slide-in flex flex-col px-1">
  <NFTButton toggleNFT={toggleNFT} handleToggleDisplay={handleToggleDisplay} />
  <SpriteButton toggleTwoD={toggleTwoD} />
  <div className="animation-toggle font-bold" onClick={handleOpen}>
      <svg
        fill="#ffffff"
        width="50px"
        height="50px"
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Animations</title>
        <g id="bb9f4e02-7318-4dbb-9960-e0435cf0cad7" data-name="Layer 3">
          <path d="M3.5,23.77a6.41,6.41,0,0,0,9.33,8.67A11.65,11.65,0,0,1,3.5,23.77Z" />
          <path d="M7.68,14.53a9.6,9.6,0,0,0,13.4,13.7A14.11,14.11,0,0,1,7.68,14.53Z" />
          <path d="M21.78,2A12.12,12.12,0,1,1,9.66,14.15,12.12,12.12,0,0,1,21.78,2" />
        </g>
      </svg>
      {open ? (
        <ul className="menu">
          <li className="menu-item">
            <button onClick={handleMenuOne}>WAVE</button>
          </li>
          <li className="menu-item">
            <button onClick={handleMenuTwo}>WALK</button>
          </li>
          <li className="menu-item">
            <button onClick={handleMenuThree}>IDLE</button>
          </li>
          <li className="menu-item">
            <button onClick={handleMenuFour}>DANCE</button>
          </li>
        </ul>
      ) : null}
    </div>
  </div>
    
  );
}

export default AnimationMenu;
